import React from "react"
import withHooks from "../../Common/jsx/WithHooks"
import { getPlants } from "../../api/api_plant"
import * as d3 from "d3"

class GGPlantsFellowships extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)
    this.state = {
      isReadyToRender: false,
      entities: [],
    }
    this.dMgr.debug("init_state:", this.state)

    this.getEntities = this.getEntities.bind(this)

    this.fellows = [
      { id: "1", plant_id: "1", is_friend: "1", fellow_id: "3" },
      { id: "6", plant_id: "2", is_friend: "1", fellow_id: "13" },
      { id: "7", plant_id: "2", is_friend: "1", fellow_id: "27" },
      { id: "8", plant_id: "2", is_friend: "1", fellow_id: "34" },
      { id: "9", plant_id: "2", is_friend: "1", fellow_id: "36" },
      { id: "10", plant_id: "3", is_friend: "1", fellow_id: "1" },
      { id: "11", plant_id: "3", is_friend: "1", fellow_id: "5" },
      { id: "12", plant_id: "3", is_friend: "1", fellow_id: "6" },
      { id: "13", plant_id: "3", is_friend: "1", fellow_id: "8" },
      { id: "14", plant_id: "3", is_friend: "1", fellow_id: "13" },
      { id: "15", plant_id: "3", is_friend: "1", fellow_id: "14" },
      { id: "16", plant_id: "3", is_friend: "1", fellow_id: "18" },
      { id: "17", plant_id: "3", is_friend: "1", fellow_id: "19" },
      { id: "18", plant_id: "3", is_friend: "1", fellow_id: "20" },
      { id: "19", plant_id: "3", is_friend: "1", fellow_id: "24" },
      { id: "20", plant_id: "3", is_friend: "1", fellow_id: "27" },
      { id: "21", plant_id: "3", is_friend: "1", fellow_id: "32" },
      { id: "22", plant_id: "3", is_friend: "1", fellow_id: "33" },
      { id: "23", plant_id: "3", is_friend: "1", fellow_id: "42" },
      { id: "24", plant_id: "3", is_friend: "1", fellow_id: "44" },
      { id: "25", plant_id: "4", is_friend: "1", fellow_id: "13" },
      { id: "26", plant_id: "4", is_friend: "1", fellow_id: "18" },
      { id: "27", plant_id: "4", is_friend: "1", fellow_id: "19" },
      { id: "28", plant_id: "4", is_friend: "1", fellow_id: "27" },
      { id: "29", plant_id: "4", is_friend: "1", fellow_id: "32" },
      { id: "30", plant_id: "4", is_friend: "1", fellow_id: "33" },
      { id: "31", plant_id: "4", is_friend: "1", fellow_id: "36" },
      { id: "32", plant_id: "4", is_friend: "1", fellow_id: "42" },
      { id: "33", plant_id: "4", is_friend: "0", fellow_id: "44" },
      { id: "34", plant_id: "5", is_friend: "0", fellow_id: "3" },
      { id: "35", plant_id: "5", is_friend: "0", fellow_id: "13" },
    ]
  }

  componentDidMount() {
    this.getEntities()
  }

  async getEntities() {
    let parameters = {}
    let entities = await getPlants(parameters)
    this.setState({ isReadyToRender: true, entities: entities["hydra:member"] })
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    return (
      <>
        <br />
        <div className="text-center">DIAGRAM HERE</div>
      </>
    )
  }
}

export default withHooks(GGPlantsFellowships)
